import {
  takeLatest,
  takeEvery,
  all,
  put,
  call,
  cancelled
} from 'redux-saga/effects'
import { actions as homeActions } from './HomeReducer'
import { formQuery } from 'components/FeedBuilder'
// import { actions as notificationActions } from 'modules/notification/NotificationReducer'
// import { getProfileSpecialtyIdByLabel } from 'modules/specialty-mapping/SpecialtyMapping'
import { delay, getTimeRange, getRandomInt } from 'utils'
import config from 'site.config.json'
const {
  configuration: {
    aimatch,
    assetPath,
    interestFeed,
    newsFeed,
    searchResult,
    articleFeed,
    tracking,
    envVars
  },
  sections: {
    leftRail: { curriculaJSON, podcastJSON, eventJSON }
  }
} = config

// const showNotification = false

export function* getNewsFeed(services, { payload }) {
  const apiService = services('APIService')
  const cookieService = services('CookieService')
  while (!cookieService.get('authToken')) yield delay(50)

  let authToken = null
  try {
    authToken = JSON.parse(cookieService.get('authToken'))
  } catch (e) {
    console.error('Failed to parse authToken:', e.message)
    yield call([cookieService, 'remove'], 'authToken')
  }
  while (!authToken?.access) {
    yield delay(2000)
    if (cookieService.get('authToken'))
      authToken = JSON.parse(cookieService.get('authToken'))
  }

  const maxRetries = 20
  const retryDelay = 500
  let attempt = 0
  let success = false

  while (attempt < maxRetries && !success) {
    try {
      const baseUrl =
        envVars?.REACT_APP_PHNX_API ?? process.env.REACT_APP_PHNX_API
      const url = baseUrl + newsFeed.path
      const isOpenSearch = false

      let query = newsFeed.query
      query.page = payload.currentPage
      // Text Search query
      // if (payload.searchTerm)
      //   query.textSearch = {
      //     text: payload.searchTerm,
      //     fields: [
      //       'title',
      //       'human_url',
      //       'extra_fields.article_url',
      //       'extra_fields.searchtext',
      //       'extra_fields.authors',
      //       'tags.conditions',
      //       'tags.specialties',
      //       'tags._all'
      //     ]
      //   }
      // else delete query.textSearch
      // Expiration date filter
      // const expiration_date = Math.floor(Date.now() / 1000)
      // query.newsFeed.must.range[
      //   'extra_fields.expiration_date'
      // ].gte = expiration_date
      // Active filters
      const { to, from } = getTimeRange(query.timeRange.duration)
      query.timeRange.to = to
      query.timeRange.from = from
      query = formQuery(payload, query, isOpenSearch)

      authToken = JSON.parse(cookieService.get('authToken'))
      const additionalHeader = {
        Authorization: `Bearer ${authToken.access}`
      }

      const result = yield call(
        [apiService, 'postWithHeaders'],
        url,
        query,
        additionalHeader
      )

      yield put(homeActions.requestNewsSuccess(result))
      success = true
    } catch (e) {
      attempt++
      if (attempt < maxRetries) {
        yield delay(retryDelay)
      } else {
        yield put(homeActions.requestNewsFail(e))
      }
    }
  }
}

export function* getInterestFeed(services, { payload }) {
  const apiService = services('APIService')
  const cookieService = services('CookieService')
  while (!cookieService.get('authToken')) yield delay(50)

  let authToken = null
  try {
    authToken = JSON.parse(cookieService.get('authToken'))
  } catch (e) {
    console.error('Failed to parse authToken:', e.message)
    yield call([cookieService, 'remove'], 'authToken')
  }
  while (!authToken?.access) {
    yield delay(2000)
    if (cookieService.get('authToken'))
      authToken = JSON.parse(cookieService.get('authToken'))
  }

  const maxRetries = 20
  const retryDelay = 500
  let attempt = 0
  let success = false

  while (attempt < maxRetries && !success) {
    try {
      const baseUrl =
        envVars?.REACT_APP_PHNX_API ?? process.env.REACT_APP_PHNX_API
      const url = baseUrl + interestFeed.path
      const isOpenSearch = false

      let query = interestFeed.query
      query.page = payload.currentPage
      const { to, from } = getTimeRange(query.timeRange.duration)
      query.timeRange.to = to
      query.timeRange.from = from
      query = formQuery(payload, query, isOpenSearch)

      authToken = JSON.parse(cookieService.get('authToken'))
      const additionalHeader = {
        Authorization: `Bearer ${authToken.access}`
      }

      const result = yield call(
        [apiService, 'postWithHeaders'],
        url,
        query,
        additionalHeader
      )

      yield put(homeActions.requestInterestSuccess(result))
      success = true
    } catch (e) {
      attempt++
      if (attempt < maxRetries) {
        yield delay(retryDelay)
      } else {
        yield put(homeActions.requestInterestFail(e))
      }
    }
  }
}

export function* getSearchResult(services, { payload }) {
  const cookieService = services('CookieService')
  while (!cookieService.get('authToken')) yield delay(50)
  try {
    const authToken = JSON.parse(cookieService.get('authToken'))
    const apiService = services('APIService')
    const baseUrl =
      envVars?.REACT_APP_PHNX_API ?? process.env.REACT_APP_PHNX_API
    const url = baseUrl + searchResult.path

    let query = searchResult.query
    query.pagination.page = payload.currentPage
    // Text Search query
    if (payload.searchTerm)
      query.textSearch = {
        ...searchResult.query.textSearch,
        text: payload.searchTerm
      }
    else delete query.textSearch
    // Expiration date filter
    const expiration_date = Math.floor(Date.now() / 1000)
    query.searchTerms.must.range[
      'extra_fields.expiration_date'
    ].gte = expiration_date

    const additionalHeader = {
      Authorization: `Bearer ${authToken.access}`
    }
    const result = yield call(
      [apiService, 'postWithHeaders'],
      url,
      query,
      additionalHeader
    )
    yield put(homeActions.requestSearchSuccess(result))
  } catch (e) {
    yield put(homeActions.requestSearchFail(e))
  }
}

export function* getArticle(services, { payload }) {
  const cookieService = services('CookieService')
  while (!cookieService.get('authToken')) yield delay(50)
  try {
    const authToken = JSON.parse(cookieService.get('authToken'))
    const apiService = services('APIService')
    const baseUrl =
      envVars?.REACT_APP_PHNX_API ?? process.env.REACT_APP_PHNX_API
    const url = baseUrl + articleFeed.path

    let query = articleFeed.query
    query.human_url = payload.human_url

    const additionalHeader = {
      Authorization: `Bearer ${authToken.access}`
    }
    const result = yield call(
      [apiService, 'postWithHeaders'],
      url,
      query,
      additionalHeader
    )

    yield put(homeActions.requestArticleSuccess(result))
  } catch (e) {
    yield put(homeActions.requestArticleFail(e))
  }
}

export function* getAd(services, { payload }) {
  if (!payload.type) yield cancelled()
  try {
    const apiService = services('APIService')
    const sessionService = services('SessionService')

    let url = aimatch[payload.type]
    url = url.replaceAll(
      '<viewid>',
      payload?.viewid ?? getRandomInt(1000, 9999).toString()
    )
    url = url.replaceAll(
      '<pid>',
      payload?.pid ?? getRandomInt(100000, 999999).toString()
    )
    url = url.replaceAll(
      '<random>',
      payload?.random ?? getRandomInt(10000, 99999).toString()
    )

    const setPayloadFromCache = (payload, key, cacheKey) => {
      payload[key] = payload?.[key] || sessionService.getFromCache(cacheKey, '')
    }

    setPayloadFromCache(payload, 'partyId', 'MemberID')
    setPayloadFromCache(payload, 'partyEmailId', 'EmailID')
    setPayloadFromCache(payload, 'countryCode', 'CountryCode')
    setPayloadFromCache(payload, 'professionId', 'ProfessionID')
    if (!payload.specialtyId)
      setPayloadFromCache(payload, 'specialtyId', 'SpecialtyID')

    url = url.replaceAll('<mid>', payload.partyId || '1')
    url = url.replaceAll('<personid>', payload.partyId || '')
    url = url.replaceAll('<emailid>', payload.partyEmailId || '')
    url = url.replaceAll('<geography>', payload.countryCode || 'US')
    url = url.replaceAll('<prof>', payload.professionId || '12')
    url = url.replaceAll('<spec>', payload?.specialtyId ?? '')
    url = url.replaceAll('<position>', payload?.position ?? 'centerrail')
    url = url.replaceAll('<channel>', 'aicme')
    // Interaction ID
    const interactionId = sessionService
      .getFromCache(tracking.clarity.identifiers['custom-session-id'], '')
      ?.toString()
    url = url.replaceAll('<interactionid>', interactionId || '')

    const req = yield call([apiService, 'getWithoutAnyHeaders'], url)
    yield put(
      homeActions.requestAdSuccess({ req, extra: { random: payload.random } })
    )
  } catch (e) {
    yield put(homeActions.requestAdFail(e))
  }
}

export function* getCurricula(services) {
  try {
    const apiService = services('APIService')
    const baseUrl = envVars.REACT_APP_JSON_URL + '/' + assetPath + '/'
    const url = baseUrl + curriculaJSON + `?nocache=${Date.now()}`
    const req = yield call([apiService, 'getWithoutAnyHeaders'], url)
    yield put(homeActions.requestCurriculaSuccess(req))
  } catch (e) {
    yield put(homeActions.requestCurriculaFail(e))
  }
}

export function* getPodcasts(services) {
  try {
    const apiService = services('APIService')
    const baseUrl = envVars.REACT_APP_JSON_URL + '/' + assetPath + '/'
    const url = baseUrl + podcastJSON + `?nocache=${Date.now()}`
    const req = yield call([apiService, 'getWithoutAnyHeaders'], url)
    yield put(homeActions.requestPodcastsSuccess(req))
  } catch (e) {
    yield put(homeActions.requestPodcastsFail(e))
  }
}

export function* getEvents(services) {
  try {
    const apiService = services('APIService')
    const baseUrl = envVars.REACT_APP_JSON_URL + '/' + assetPath + '/'
    const url = baseUrl + eventJSON + `?nocache=${Date.now()}`
    const req = yield call([apiService, 'getWithoutAnyHeaders'], url)
    yield put(homeActions.requestEventsSuccess(req))
  } catch (e) {
    yield put(homeActions.requestEventsFail(e))
  }
}

export default function* watchHome(services) {
  yield all([
    takeLatest(homeActions.requestNews, getNewsFeed, services),
    takeLatest(homeActions.requestInterest, getInterestFeed, services),
    takeLatest(homeActions.requestSearch, getSearchResult, services),
    takeLatest(homeActions.requestArticle, getArticle, services),
    takeLatest(homeActions.requestCurricula, getCurricula, services),
    takeLatest(homeActions.requestPodcasts, getPodcasts, services),
    takeLatest(homeActions.requestEvents, getEvents, services),
    takeEvery(homeActions.requestAd, getAd, services)
  ])
}
